import stateController from './stateController';
const nextButton = document.querySelector('.next-button');

const storyteller = (function() {
    let scrollPaused = false;
    function init() {
        nextButton.addEventListener('click', nextStory);
        document.addEventListener('wheel', _scrollNext);
        document.addEventListener('keydown', e => {
            if (e.keyCode === 39 || e.keyCode === 40 || e.keyCode === 32) {
                _goNext();
            } else if (e.keyCode === 38 || e.keyCode === 37) {
                _goPrev();
            }
        });
    }
    function nextStory() {
        stateController.next();
    }
    function _setTimer() {
        scrollPaused = true;
        setTimeout(() => {
            scrollPaused = false;
        }, 2500);
    }
    function _goNext() {
        if (scrollPaused) {
            return;
        }
        _setTimer();
        stateController.next();
    }
    function _goPrev() {
        if (scrollPaused) {
            return;
        }
        _setTimer();
        stateController.prev();
    }
    function _scrollNext(e) {
        if (scrollPaused) {
            return;
        }
        _setTimer();
        if (e.deltaY > 0) {
            stateController.next();
        } else {
            stateController.prev();
        }
    }
    return {
        init: init
    };
})();
export default storyteller;
